



































import { vxm } from '@/store.vuex';
import { Component, Vue } from 'vue-property-decorator';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000
});

@Component({
  name: 'ThankYou',
  components: {}
})
export default class SurveyQuestionnaire extends Vue {
  searchJobs() {
    // To add findjob , signin and signup menu
    vxm.utility.setAppWebView(false);
    router.push({ path: 'findjobs' });
  }

  mounted() {
    vxm.utility.setAppWebView(true);
  }
}
